import axios from 'axios';
import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

const cotton = envConfig.formalServer + "/cotton"
// const cotton = 'https://server.cottongame.com/cotton'


//--- Header.vue
export const userAdminUpdatePassword = params => axios.post(cotton + '/userAdminUpdatePassword', params)   // 修改个人密码


//--- Register.vue
export const userAdminRegister = params => Post(envConfig.formalServer + '/cotton/userAdminRegister', params)   // 注册账号


//--- Login.vue
export const userAdminLogin = params => Post(envConfig.formalServer + '/cotton/userAdminLogin', params)                 // 登录账号
export const selProjectRoleByUserId = params => axios.post(cotton + '/selProjectRoleByUserId', params) // 获取角色权限信息

// 查询所有的内部用户信息
export function selectEmployeeList(data) {
    return Post(envConfig.formalServer + '/cotton/selectEmployeeList', data);
}